import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import api from '../../../../../api';

interface FileUploadResponse {
  fileId: string;
  postData: {
    fields: Record<string, string>;
    url: string;
  };
}

export interface ErrorResponseData {
  message: string;
  statusCode: number;
  details: {
    maxFileSize?: number;
  };
}

export function getErrorData(error: unknown | AxiosError): ErrorResponseData {
  if (axios.isAxiosError(error)) return error.response?.data;
  return {
    message: String(error),
    statusCode: 500,
    details: {},
  };
}

export const FILE_UPLOAD_ERROR_RESPONSES = {
  EXTENSION_NOT_ACCEPTED: 'EXTENSION_NOT_ACCEPTED',
  FILE_SIZE_EXCEEDED: 'FILE_SIZE_EXCEEDED',
};

export async function getAWSUploadFields(token: string, file: File, studioGroup: string) {
  try {
    const { data: response } = await api.post<FileUploadResponse>(
      '/studio/user-material/files',
      {
        originalFileName: file.name,
        mimeType: file.type,
        size: file.size,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          studioGroup,
        },
      },
    );

    return response;
  } catch (error) {
    throw getErrorData(error);
  }
}

export function buildMultipartFormData(file: File, formDataFields: Record<string, string>): FormData {
  const formData = new FormData();

  formData.append('Content-Type', file.type);

  Object.entries(formDataFields).forEach(([k, v]) => {
    formData.append(k, v);
  });

  formData.append('file', file, file.name);

  return formData;
}

export async function uploadFile(
  postData: {
    url: string;
    fields: Record<string, string>;
  },
  file: File,
  axiosConfig: AxiosRequestConfig,
) {
  const formData = buildMultipartFormData(file, postData.fields);
  const { data } = await api.post(postData.url, formData, axiosConfig);
  return data;
}
